import { Injectable } from '@angular/core';
import { HttpUtils } from '../../../../shared/http/HttpUtils';
import { BuilderRegisterApiRequest } from './Models/BuilderRegisterApiRequest';

@Injectable({
    providedIn: 'root'
})

export class BuilderRegisterApi
{
    private apiUrl = '/api/builder/register';

    public async PostAsync(request: BuilderRegisterApiRequest): Promise<void>
    {
        const response = await fetch(`${this.apiUrl}`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(request)
        });

        await HttpUtils.ProcessFetchResultAsync(response);
    }
}
